import { VoucherResponse, HybrisVouchersRepsonse } from '../types'

export const normalizeVouchersResponse = (
  vouchersResponse: HybrisVouchersRepsonse,
): VoucherResponse => {
  const { vouchersApplied, ...restOfVouchersResponse } = vouchersResponse

  return {
    appliedVouchers: vouchersApplied,
    ...restOfVouchersResponse,
  }
}
